import type { DeleteKanbanColumnPayload, KanbanContext } from '@rhythmic/types'
import { DeleteKanbanColumnSchema, KanbanContextSchema } from '@rhythmic/types'
import type { Transaction } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'

import { getColumnsCollection } from '../getCollections'

const logger = useRhythmicLogger('useKanbanBoardContext.deleteColumn')

function validateParams(payload: DeleteKanbanColumnPayload, context: KanbanContext | undefined) {
  if (!context) {
    logger.error('Attempted to delete column without an active kanban context')
    throw new Error('Kanban board context is not ready: missing context for deleting a column')
  }

  logger.debug('Validating parameters for handleDeleteColumn', {
    payload,
    context,
  })

  const parsedContext = KanbanContextSchema.parse(context)
  const parsedPayload = DeleteKanbanColumnSchema.parse(payload)

  return {
    context: parsedContext,
    payload: parsedPayload,
  }
}

export default function handleDeleteColumn(
  payload: DeleteKanbanColumnPayload,
  context: KanbanContext | undefined,
): Transaction {
  const { context: validatedContext, payload: validatedPayload } = validateParams(payload, context)
  const columnsCollection = getColumnsCollection(validatedContext.boardId)

  logger.debug('Deleting harmony package board column from collection', {
    boardId: validatedContext.boardId,
    columnId: validatedPayload.columnId,
  })

  const deleteResult = columnsCollection.delete(validatedPayload.columnId)
  return deleteResult
}
